<div class="menu">
  <div class="navigation navigation-scrollable">
    <ul nz-menu [nzMode]="'horizontal'" [ngStyle]="{'white-space': 'nowrap'}">
      <ng-container *ngFor="let item of menuDataChildrenActivated">
        <!-- main item -->
        <ng-container *ngIf="display(item)">
          <ng-container *ngIf="hasAccess(item); else disabledLink">
            <li class="ant-menu-item ng-star-inserted" routerLinkActive="ant-menu-item-selected">
              <a routerLink={{item.url}} title="{{ item.title }}">
                <span class="title">{{ item.title }}</span>
              </a>
            </li>
          </ng-container>
          <ng-template #disabledLink>
            <li class="ant-menu-item ng-star-inserted">
              <a title="{{ item.title }}" class="disabled">
                <span class="title">{{ item.title }}</span>
              </a>
            </li>
          </ng-template>
        </ng-container>
      </ng-container>
    </ul>
  </div>
</div>
